module.exports = __webpack_public_path__ + "static/media/3.6ed0a9e4.JPG";